import { api } from '@/api/api.v2';
import { proxy } from 'valtio';
import { customAlphabet } from 'nanoid';

import * as wellsRappers from './';
import type { ClicksCountWell } from '../types/clicks';
import type { CreateRappersStore, CreateRappersPayload } from '../types/wellsRappers';

const nanoid = () => +customAlphabet('1234567890', 10)();

/*
    * store пока нигде не используется, так как операция создания является частью другого store.
*/
export const store: CreateRappersStore = proxy({
    isLoading: false,
    isError: false,
});

/*
    Запрос на создание rapper-ов у скважин
*/
export const createWellsRappers = async (payload: CreateRappersPayload) => {
    const body = JSON.stringify(payload);
    return await api.carottage.createWellsRappers(body);
};

/*
    ====== Public Methods ======
*/

/*
    Создание нового rapper-a
*/
export const createRapper = (wellId: number, activePackId: number, clicks: ClicksCountWell) => {
    const { first, second } = clicks;

    /*
        Если хоть чего то нет, отменяем создание.
    */
    if (!(first && second)) {
        // eslint-disable-next-line no-console
        console.error('clicks is invalid');
        return;
    }

    const id = nanoid();
    const isRightWay = second.px > first.px;

    const createdRapper = {
        id,
        wellId,
        packID: activePackId,
        roof: isRightWay ? first.rel : second.rel,
        bottom: isRightWay ? second.rel : first.rel,
        absRoof: isRightWay ? first.abs : second.abs,
        absBottom: isRightWay ? second.abs : first.abs,
        isNew: true,
    };

    wellsRappers.addRappersToWell(wellId, createdRapper);
};
